import { render } from "./Edit.vue?vue&type=template&id=361cb3ec"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Admin/Tenants/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "361cb3ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('361cb3ec', __exports__)) {
    api.reload('361cb3ec', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=361cb3ec", () => {
    api.rerender('361cb3ec', render)
  })

}


export default __exports__